import React from 'react';
import Footer from '../../Home/Footer/Footer';
import Header from '../../Share/Header/Header';
import SingleTeam from './SingleTeam';

const DoctorHeader = () => {
    return (
        <>
            <Header />
            <SingleTeam />
           <Footer /> 
        </>
    );
};

export default DoctorHeader;